import { render, staticRenderFns } from "./OneOffPayments.vue?vue&type=template&id=49548b93&scoped=true&"
import script from "./OneOffPayments.vue?vue&type=script&lang=js&"
export * from "./OneOffPayments.vue?vue&type=script&lang=js&"
import style0 from "./OneOffPayments.vue?vue&type=style&index=0&id=49548b93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49548b93",
  null
  
)

export default component.exports